import * as firebase from "firebase";

export default {
    state: {
        aboutMeData: undefined,
        aboutMeLoading: false
    },
    getters: {
        getHeader(state) {
            return state.aboutMeData.header;
        },
        getCurrentPosition(state) {
            return state.aboutMeData.currentPosition;
        },
        getAcademics(state) {
            return state.aboutMeData.academics;
        },
        getPublications(state) {
            return state.aboutMeData.publications;
        },
        aboutMeLoading(state) {
            return state.aboutMeLoading;
        }
    },
    mutations: {
        setAboutMeData(state, payload) {
            state.aboutMeData = payload;
        },
        setAboutmeLoading(state, payload) {
            state.aboutMeLoading = payload;
        }
    },
    actions: {
        fetchAboutMeData({commit}) {
            commit("setAboutmeLoading", true);
            firebase.database().ref("/aboutMe/").once("value")
                .then((data) => {
                    const aboutMeData = data.val();
                    commit("setAboutMeData", aboutMeData);
                    commit("setAboutmeLoading", false);
                })
                .catch((error) => {
                    commit("setErrorMessage", error.message);
                    commit("setAboutmeLoading", false);
                });
        }
    },
    modules: {}
}